<template>
  <div class="user-records">
      <v-tabs fixed-tabs slider-color="#ff2d55" v-model="activeTab" @change="tabSelected">
        <v-tab>
          {{ $t('records.tab_approved') }}
        </v-tab>
        <v-tab>
          {{ $t('records.tab_deleted') }}
        </v-tab>
      </v-tabs>
    <div v-show="loading && !records.length" class="loading-indicator center-block"></div>
    <records-list
      :records="records"
      @delete-record="handleRecordDelete"
      @restore-record="handleRecordRestore"
      @mark-record-relevance="markRecordRelevance"
      @clicked-record="showRecordDetails"
    />
    <div v-show="!loading && records.length">
      <v-pagination
        v-model="recordsPage"
        @input="fetchRecords('VIDEO')"
        :length="calculateAmountPages('VIDEO')"
        :total-visible="10"
      ></v-pagination>
    </div>
    <div v-if="imageRecords.length > 0">
      <h2>{{ $t('menu.images') }}</h2>
      <div>
        <records-list
          :records="imageRecords"
          @delete-record="handleRecordDelete"
          @restore-record="handleRecordRestore"
          @mark-record-relevance="markRecordRelevance"
          @clicked-record="showRecordDetails"
          />
        <div v-show="!loading">
          <v-pagination
            v-model="recordsPage"
            @input="fetchRecords('IMAGE')"
            :length="calculateAmountPages('IMAGE')"
            :total-visible="10"
          ></v-pagination>
        </div>
      </div>
    </div>
    <record-details
      :record="selectedRecord"
      v-if="selectedRecord"
      @clicked-similar-record="showRecordDetails"
      @close="selectedRecord = null">
    </record-details>

  </div>
</template>

<script>
import RecordsList from '../marker/record/RecordsList'
import RecordRepository from '../../repositories/RecordRepository'
import events from '../../services/events'
import RecordDetails from '../marker/record/RecordDetails.vue'

export default {
  components: {
    RecordsList,
    RecordDetails
  },
  data () {
    return {
      records: [],
      imageRecords: [],
      loading: true,
      activeTab: 0,
      pageSize: 20,
      recordsPage: 1,
      imagesPage: 1,
      selectedRecord: null
    }
  },
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  mounted () {
    this.fetchRecords('VIDEO')
    this.fetchRecords('IMAGE')
  },
  methods: {
    fetchRecords (recordType) {
      this.loading = true
      let page = recordType === 'VIDEO' ? this.recordsPage : this.imagesPage
      RecordRepository.fetchUserRecords(this.userId, page, this.pageSize, recordType, this.activeTab).then(records => {
        this.loading = false
        this.setRecords(recordType, records)
      }, (error) => {
        this.loading = false
        events.emit('error', error)
      })
    },
    setRecords (recordType, records) {
      if (recordType === 'VIDEO') {
        this.records = records
      } else {
        this.imageRecords = records
      }
    },
    handleRecordDelete ({ id }, recordType) {
      RecordRepository.deleteUserRecord(this.userId, id).then(() => {
        this.fetchRecords(recordType)
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    handleRecordRestore ({ id }, recordType) {
      RecordRepository.restoreUserRecord(this.userId, id).then(() => {
        this.fetchRecords(recordType)
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    markRecordRelevance ({ id }, relevance, recordType) {
      const r = this.getRecords(recordType).find((r) => { return r.id === id })
      if (r && r.mldata) {
        r.mldata.marked_as_relevant = relevance
      }
      RecordRepository.patchUserRecordRelevance(this.userId, id, relevance)
      .catch((error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    getRecords (recordType) {
      const typeMapping = {
        'VIDEO': this.records,
        'IMAGE': this.imageRecords
      }
      return typeMapping[recordType]
    },
    tabSelected () {
      this.fetchRecords('VIDEO')
      this.fetchRecords('IMAGE')
    },
    calculateAmountPages (recordType) {
      let records = recordType === 'VIDEO' ? this.records : this.imageRecords
      return Math.ceil(records.count / this.pageSize) || 1
    },
    showRecordDetails (record) {
      this.selectedRecord = record
    }
  }
}
</script>
